import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import { Sentry } from './sentry'

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) =>
      Sentry.captureException(error, {
        tags: { 'reactQuery.queryKey': JSON.stringify(query.queryKey) },
      }),
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) =>
      Sentry.captureException(error, {
        tags: { 'reactQuery.mutationKey': JSON.stringify(mutation.options.mutationKey) },
      }),
  }),
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

export default queryClient
